import Vue from 'vue'
import Toasted from 'vue-toasted'

const options = {
  icon: 'iconfont icon-status-success status',
  iconPack: 'custom-class',
  className: 'custom-toast',
  position: 'top-center',
  duration: 3 * 1000,
  fullWidth: true,
  theme: 'outline',
  action: {
    icon: 'iconfont icon-close action',
    // text: '关闭',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
}

Vue.use(Toasted, options)

Vue.prototype.$message = {
  success (msg, opts = {}) {
    Vue.toasted.show(msg, {
      type: 'success',
      ...opts,
      action: opts.notClose ? null : {
        ...options.action,
        icon: `iconfont icon-close action success`
      }
    })
  },
  error (msg, opts = {}) {
    Vue.toasted.show(msg, {
      type: 'error',
      icon: 'iconfont icon-error status',
      ...opts,
      action: opts.notClose ? null : {
        ...options.action,
        icon: `iconfont icon-close action error`
      }
    })
  },
  info (msg, opts = {}) {
    Vue.toasted.show(msg, {
      type: 'info',
      icon: 'iconfont icon-warning status',
      ...opts,
      action: opts.notClose ? null : {
        ...options.action,
        icon: `iconfont icon-close action warning`
      }
    })
  }
}

export default Vue.prototype.$message



// WEBPACK FOOTER //
// ./src/utils/toast.js